import store from "../../store";
import {RootState} from "../../storeHooks";
import {Feature} from "../../interfaces/Feature";
import {updatePriceWithMarkUp} from "../priceFunctions";
import {updatePriceWithFeatureMarkUp} from "../markUpFunctions";
import {getPricingGridFeaturePrice} from "./pricingGridFunctions";

interface UpdateFeaturePriceParams {
  price: number;
  storeState?: RootState;
  feature?: Feature;
  activeQuoteIndex?: number;
  applyPricingGrid?: boolean; // stones have no pricing grid (for now)
}

export default function updateFeaturePriceWithGridAndMarkUp({
  price,
  storeState = store.getState(),
  feature,
  activeQuoteIndex,
  applyPricingGrid = true,
}: UpdateFeaturePriceParams): number {
  let updatedPrice = price;
  let priceGridMarkUp;

  const dbFeature = feature.dbFeature;
  const useBase = storeState.cartState?.markUpLogic?.useBase;

  if (!dbFeature) {
    return updatedPrice // just in case
  }

  const fabricatorSettings = storeState.fabricatorState.settings;
  const doNotApplyMarkUp = document.kvConfig.isBackend && dbFeature.priceEditable;

  if (applyPricingGrid && feature && fabricatorSettings.enablePriceGrid && !doNotApplyMarkUp) {
    const useCostTable = useBase && (useBase === "useCostAsBase");
    const {priceFromGrid, gridMarkUp} = getPricingGridFeaturePrice(feature, storeState, activeQuoteIndex, useCostTable);
    if (priceFromGrid !== null) {
      updatedPrice = priceFromGrid;
      priceGridMarkUp = gridMarkUp;
    }
  }

  if (useBase && (
    ((useBase === "useCostAsBase") && !fabricatorSettings.useFabricatorCostPrices)
    || ((useBase !== "useCostAsBase") && fabricatorSettings.useFabricatorCostPrices)
  )) {
    // useCostAsBase -> apply mark up off the cost price; useRetailAsBase -> off the retail price
    // first we apply their own markups, then the regular markups
    const baseFabricatorSettings = {
      ...fabricatorSettings,
      useFabricatorCostPrices: useBase === "useCostAsBase",
    };

    if (storeState.cartState.markUpLogic && !doNotApplyMarkUp) { // global
      updatedPrice = updatePriceWithMarkUp(updatedPrice, storeState.cartState.markUpLogic, baseFabricatorSettings);
    }
    if (priceGridMarkUp && !doNotApplyMarkUp) { // grid
      updatedPrice = updatePriceWithMarkUp(updatedPrice, priceGridMarkUp, baseFabricatorSettings);
    }
    if (!priceGridMarkUp && dbFeature.markUpString && !doNotApplyMarkUp) { // feature mark up should update after global
      updatedPrice = updatePriceWithFeatureMarkUp(updatedPrice, dbFeature.markUpString, baseFabricatorSettings);
    }
  }

  if (storeState.cartState.markUpLogic && !doNotApplyMarkUp) { // global
    updatedPrice = updatePriceWithMarkUp(updatedPrice, storeState.cartState.markUpLogic, fabricatorSettings);
  }
  if (priceGridMarkUp && !doNotApplyMarkUp) { // grid
    updatedPrice = updatePriceWithMarkUp(updatedPrice, priceGridMarkUp, fabricatorSettings);
  }
  if (!priceGridMarkUp && dbFeature.markUpString && !doNotApplyMarkUp) { // feature mark up should update after global
    updatedPrice = updatePriceWithFeatureMarkUp(updatedPrice, dbFeature.markUpString, fabricatorSettings);
  }

  return updatedPrice;
}
